import React from 'react'
import { useMsal } from '@azure/msal-react'
import { microsoftAuthConfiguration } from './mintAuthConfiguration'
import { clearCacheAndReauthenticate, isIframeTimeoutError, isTokenExpirationError } from '@/auth/logout'

export const AuthErrorBoundary: React.FC<{ error: any }> = ({ error }) => {
  const { instance } = useMsal()

  React.useEffect(() => {
    const errorCode = error?.error?.code
    const errorMessage = error?.error?.errorMessage || ''

    if (isIframeTimeoutError(errorCode)) {
      microsoftAuthConfiguration()
        .then((authenticationParameters) => instance.loginRedirect(authenticationParameters))
    } else if (isTokenExpirationError(errorCode, errorMessage)) {
      console.log('Token expiration detected, clearing cache and re-authenticating:', { errorCode, errorMessage })
      clearCacheAndReauthenticate(instance)
    }
  }, [error, instance])

  return <>
    <div>Authentication error: {error.error?.errorMessage}.</div>
    <div>If page is not redirected to sign-in, refresh the page manually.</div>
  </>
}
